import {
  useUpdateOrCreateOrganizationRosterPreferenceMutation,
  useUpdateOrganizationRosterEntryMutation,
} from '@client/graphql/__generated__/main-operations';
import {
  PartnerPreferenceType,
  PartnerType,
} from '@client/graphql/__generated__/types';
import { useCallback } from 'react';

interface UpdatePreferenceParams {
  rosterEntryId: string;
  partnerType: PartnerType;
  preferenceType: PartnerPreferenceType;
  partnerId?: string | null;
  partnerContactId?: string | null;
}

export function useRosterPreferenceMutation() {
  const [updatePreference, { loading: updatingPreference }] =
    useUpdateOrCreateOrganizationRosterPreferenceMutation();

  const [updateRosterEntry, { loading: updatingEntry }] =
    useUpdateOrganizationRosterEntryMutation();

  const updatePartnerPreference = useCallback(
    async (params: UpdatePreferenceParams) => {
      await updatePreference({
        variables: {
          input: {
            rosterEntryId: params.rosterEntryId,
            partnerType: params.partnerType,
            preferenceType: params.preferenceType,
            partnerId: params.partnerId ?? undefined,
            partnerContactId: params.partnerContactId ?? undefined,
          },
        },
      });
    },
    [updatePreference]
  );

  const updateContactable = useCallback(
    async (rosterEntryId: string, isContactable: boolean) => {
      await updateRosterEntry({
        variables: {
          input: {
            id: rosterEntryId,
            isContactable,
          },
        },
      });
    },
    [updateRosterEntry]
  );

  return {
    updatePartnerPreference,
    updateContactable,
    loading: updatingPreference || updatingEntry,
  };
}
